// eslint-disable-next-line no-restricted-imports
import camelcaseKeysRaw from 'camelcase-keys';
import type { CamelCasedPropertiesDeep } from 'type-fest';


export type { CamelCase } from 'type-fest';
export type CamelCaseKeys<T> = CamelCasedPropertiesDeep<T>;
type Obj = { [key: string]: unknown };
export type JSONData = Obj | ReadonlyArray<Obj> | null | undefined;
export const camelcaseKeys = <T>(data: T) => {
  if (!data) return data as unknown as CamelCaseKeys<T>;
  return camelcaseKeysRaw(data, {
    deep: true,
    exclude: [
      /^.{8}-.{4}-.{4}-.{4}-.{12}$/, // ignore UUID keys
    ],
  }) as unknown as CamelCaseKeys<T>;
};

export const toCamel = (str: string) => str.toLowerCase().replace(/[-_][a-z]/g, (group) => group.slice(-1).toUpperCase());
